import { render, staticRenderFns } from "./additionalDialog.vue?vue&type=template&id=7bfd6d1e"
import script from "./additionalDialog.vue?vue&type=script&lang=js"
export * from "./additionalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports